module.exports = __webpack_public_path__ + "img/kayak2.40c240b5.jpg";